import { render, staticRenderFns } from "./email_outbox.vue?vue&type=template&id=02f859a7&"
import script from "./email_outbox.vue?vue&type=script&lang=js&"
export * from "./email_outbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports